//import _ from 'lodash';

export default {
  namespace: 'core',
  state: {
    /*
    processing: false,
    message: {display: false, text: null, type: type},
    trans: []
    meta:[]
    */
  },
  reducers: {
    /**
     *
     * @param processing: boolean
     * @returns {{processing: boolean}}
     */
    processing(state, {processing}) {
      return {...state, processing: processing};
    },
    /**
     *
     * @param message: string
     * @param error: boolean
     * @returns {{message: *, error: *, processing: boolean}}
     */
    message(state, {message, type = false}) {
      return {...state, message: {display: false, text: message, type: type}, processing: false};
    },

    /**
     *
     * @param message: string
     * @param error: boolean
     * @returns {{message: *, error: *, processing: boolean}}
     */
    initMeta(state, {data}){
      /*
      const trans = {};
      if(data.trans){
        trans.get  = (label) => {
          return (data.trans[label])?data.trans[label]:label;
        }
        delete data.trans;
      }
//      console.info('[TRAN]', trans);
      console.info(data);
      return { ...state, meta: data, trans: trans, ready:true};
      */
      console.info('initMeta', data);
      return { ...state, meta: data, ready:true};
    },

    /**
     * overwrite meta
     * @param state
     * @param key
     * @param value
     * @returns {{meta: {}}}
     */
    setMeta(state, {key, value}){
      console.info('setMeta:'.key, value);
      const meta = (state.meta)?state.meta:{};
      //meta.set(key, value);
      meta[key] = value;
      return { ...state, meta: meta};
    },

    updateDefaultValue(state, {key, value, ready=true}){
      const dvs = (state.defaultValues)?state.defaultValues:{};
      dvs[key] = value;
      console.info(dvs);
      return { ...state, defaultValues: dvs, ready: ready};
    },

  },
  /*
effects: {
  *save({ payload: todo }, { put, call }) {
    // Call saveTodoToServer, then trigger `add` action to save data
    yield call(saveTodoToServer, todo);
    yield put({ type: 'add', payload: todo });
  },
  },
  subscriptions: {
    setup({ history, dispatch }) {
      // Subscribe history(url) change, trigger `load` action if pathname is `/`
      return history.listen(({ pathname }) => {
        if (pathname === '/') {
          dispatch({ type: 'load' });
        }
      });
    },
  },
  */
};



// WEBPACK FOOTER //
// ./src/lib/core.js